/**
 * Zusammenfassung der von Google fuer Shopping-Anzeigen abgelehnten Produkte
 * eines Feeds (UX-Audit WP5, A2O-03). Quelle ist `products.shopping_ads_issues`
 * (Serving-Gate, taeglicher Abruf 06:45 UTC). Ein Grund zaehlt je Produkt nur
 * einmal: die Zahl beantwortet "wie viele Produkte trifft das", nicht "wie
 * oft steht der Code in der Antwort".
 */
export interface DisapprovalSummary {
  count: number;
  topIssues: Array<{ code: string; count: number }>;
}

export function summarizeDisapprovals(
  rows: ReadonlyArray<{ shopping_ads_issues: readonly string[] | null }>,
  limit = 2,
): DisapprovalSummary {
  const counts = new Map<string, number>();
  for (const row of rows) {
    for (const code of new Set(row.shopping_ads_issues ?? [])) {
      counts.set(code, (counts.get(code) ?? 0) + 1);
    }
  }
  const topIssues = [...counts.entries()]
    .sort((a, b) => b[1] - a[1] || a[0].localeCompare(b[0]))
    .slice(0, limit)
    .map(([code, count]) => ({ code, count }));
  return { count: rows.length, topIssues };
}
